// extracted by mini-css-extract-plugin
export default {"container":"orders_container__odkq3","card":"orders_card__Itutk","order_info":"orders_order_info__FospW","order_det":"orders_order_det__Dja6s","action":"orders_action__p2i4+"};